/*
 * Pins in-stock "New" products to the top of the Globo collection grid (#gf-products).
 *
 * The cards come from sections/new-pinned-products.liquid, rendered for the tag-filtered collection URL.
 * Only the default view is changed (no Globo filters, no search, the collection's default sort, first page);
 * Globo's own copies of pinned products are hidden so nothing is listed twice. Globo's sorting and
 * settings are untouched: this only reorders what is already on the page.
 */
(function () {
  const config = document.getElementById('new-pinned-products-config');
  if (!config) return;

  // Globo can override the collection's own sort, so prefer the sort Globo actually uses by default.
  const defaultSort = window.GloboEmbedFilterConfig?.collection?.sort || config.dataset.defaultSort;
  let pinnedCards = [];
  let pinnedHandles = new Set();
  let observedGrid = null;
  let scheduled = false;
  let lastLayout = '0:0';

  function handleFromItem(item) {
    const link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    return new URL(link.href, window.location.origin).pathname.split('/products/')[1]?.split('/')[0] || null;
  }

  // Globo's "load more" can move the page param on, so it is only checked before pinning.
  function isDefaultView(checkPage) {
    const params = new URLSearchParams(window.location.search);
    for (const [key, value] of params) {
      if (key.startsWith('gf_') || key.startsWith('filter.') || key === 'q') return false;
      if (key === 'sort_by' && value && value !== defaultSort) return false;
      if (checkPage && key === 'page' && value !== '1') return false;
    }
    return true;
  }

  function initWishlistButtons(scope) {
    scope.querySelectorAll('.wishlist-hero-custom-button').forEach((button) => {
      document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: button }));
    });
  }

  function apply() {
    scheduled = false;
    const grid = document.getElementById('gf-products');
    if (!grid || !pinnedCards.length) return;
    watchGrid(grid);

    let pinned = grid.querySelectorAll(':scope > [data-new-pinned]');

    if (pinned.length && !isDefaultView(false)) {
      pinned.forEach((card) => card.remove());
      pinned = [];
    }

    // Globo re-renders the grid for filters and sorting; pin again only when back on the default view.
    if (!pinned.length && isDefaultView(true) && grid.querySelector(':scope > .product-grid__item')) {
      const fragment = document.createDocumentFragment();
      pinnedCards.forEach((card) => fragment.appendChild(card.cloneNode(true)));
      grid.prepend(fragment);
      pinned = grid.querySelectorAll(':scope > [data-new-pinned]');
      pinned.forEach(initWishlistButtons);
    }

    const pinning = pinned.length > 0;
    let duplicates = 0;
    grid
      .querySelectorAll(':scope > .product-grid__item:not([data-new-pinned]):not(.product-grid__banner)')
      .forEach((item) => {
        const duplicate = pinning && pinnedHandles.has(handleFromItem(item));
        item.toggleAttribute('data-new-pinned-duplicate', duplicate);
        if (duplicate) duplicates++;
      });

    // Tell the collection page-break banners to re-place themselves, only when the pinned layout changed.
    const layout = `${pinned.length}:${duplicates}`;
    if (layout !== lastLayout) {
      lastLayout = layout;
      document.dispatchEvent(new CustomEvent('new-pinned:applied'));
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  }

  function watchGrid(grid) {
    if (observedGrid === grid) return;
    observedGrid = grid;
    new MutationObserver(schedule).observe(grid, { childList: true });
  }

  fetch(config.dataset.url, { credentials: 'same-origin' })
    .then((response) => (response.ok ? response.text() : ''))
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      pinnedCards = [...doc.querySelectorAll('[data-new-pinned]')];
      pinnedHandles = new Set(pinnedCards.map((card) => card.dataset.productHandle));
      schedule();
    })
    .catch(() => {});

  window.addEventListener('globoFilterRenderCompleted', schedule);
  window.addEventListener('popstate', schedule);
})();
